import React from 'react'
import { withTranslationCustom } from 'lib/i18next'
import { getEventReminderOptions } from 'lib/utils/store/event'

import Button from 'components/UI/Button'
import { Field } from 'formik'
import Select from 'components/Forms/FormElements/Select'
import Icon from 'components/Icon'

import './event-reminder-item.pcss'

const EventReminderItem = ({ t, fieldName, index, onRemove, removeDisabled }) => {
    return (
        <div className="event-reminder-item">
            <Field name={`${fieldName}.${index}`}>
                {(props) => (
                    <Select
                        {...props}
                        size="s"
                        options={getEventReminderOptions(t)}
                    />
                )}
            </Field>
            {!removeDisabled && (
                <Button
                    className="event-reminder-item__delete-button"
                    trackName="deleteReminder"
                    type="button"
                    onClick={() => onRemove(index)}
                >
                    <Icon fa name="minus-circle" color="#b1b1b1" />
                </Button>
            )}
        </div>
    )
}

export default withTranslationCustom('events')(EventReminderItem)
